export enum DateResolutionTypes {
    Day = 1,
    Week = 2,
    Month = 3,
    Year = 4,
}
